import { Fragment } from 'react';

const Footer = () => {
    return (
        <Fragment>
            <footer id="footer" className="footer position-relative">

                    <div className="container copyright text-center mt-4">
                        <p><span>Desarrollado por </span><strong className="px-1 sitename"><a className="solgeek" href="https://solgeek.com/" target="_blank" rel="noreferrer">Solgeek</a></strong></p>
                    </div>

            </footer>

            <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>

            <div id="preloader"></div>
        </Fragment>
    )
}

export default Footer;